<template>
  <div class="index">
    <div class="templateCollect" v-if="Data">
      <squared-Nine v-if="Data.template === 'nine'"
        @clickAward="gotoAward"
        @alertPrize="alertPrize"
        :lotteryDetail="Data"
        :prizeListData="prizeListData"
        :platRight="platRight"
        :coordinate="coordinate"
        :prizeListImgDisplay="prizeListImgDisplay"
        :preview="preview"></squared-Nine>
      <turn-Table v-if="Data.template === 'wheel'"
        @clickAward="gotoAward"
        @alertPrize="alertPrize"
        :lotteryDetail="Data"
        :prizeListData="prizeListData"
        :coordinate="coordinate"
        :platRight="platRight"
        :prizeListImgDisplay="prizeListImgDisplay"
        :preview="preview"></turn-Table>
      <scratch-Card v-if="Data.template === 'ggk'"
        @clickAward="gotoAward"
        @alertPrize="alertPrize"
        :lotteryDetail="Data"
        :prizeListData="prizeListData"
        :coordinate="coordinate"
        :platRight="platRight"
        :prizeListImgDisplay="prizeListImgDisplay"
        :preview="preview"></scratch-Card>
      <smash-Eggs v-if="Data.template === 'egg'"
        @clickAward="gotoAward"
        @alertPrize="alertPrize"
        @prizeListUpdateNotice="_getPrizeList"
        :lotteryDetail="Data"
        :prizeListImgDisplay="prizeListImgDisplay"
        :prizeListData="prizeListData"
        :coordinate="coordinate"
        :platRight="platRight"
        :preview="preview"></smash-Eggs>
      <box-Password v-if="Data.template === 'box'"
        @clickAward="gotoAward"
        @prizeListUpdateNotice="_getPrizeList"
        @alertPrize="alertPrize"
        :prizeListImgDisplay="prizeListImgDisplay"
        :lotteryDetail="Data"
        :prizeListData="prizeListData"
        :coordinate="coordinate"
        :platRight="platRight"
        :preview="preview"></box-Password>
      <shake-Tip v-if="Data.template === 'shake'"
        @clickAward="gotoAward"
        @prizeListUpdateNotice="_getPrizeList"
        @alertPrize="alertPrize"
        :prizeListImgDisplay="prizeListImgDisplay"
        :lotteryDetail="Data"
        :prizeListData="prizeListData"
        :coordinate="coordinate"
        :platRight="platRight"
        :preview="preview"></shake-Tip>
    </div>

     <!-- 活动已下架、未开始、已结束 -->
    <div v-if="status === 2" class="activeStatus">
      <img src="../assets/images/downAct.png" alt="">
      <p>{{tipInfo}}</p>
    </div>

    <!-- 注册页信息 -->
    <div class="registerArea" v-if="status === 1">
      <section class="formInfo">
        <h3 class="resg_title">请完善下列信息</h3>
        <div class="tip">
          "为保障您在活动中的权益，请您务必填写真实的个人信息,我们将对您的信息严格保密”
        </div>
        <section class="setHeight">
          <div class="box" v-for="(value, key, index) in rgtData" :key="index">
            <div class="item item-gender" v-if="key === 'gender'">
              <div class="name">{{value.field}}</div>
              <div class="genderOption">
                <!-- value 1 男 2 女 -->
                <div class="gender male" @click="genderAction(1)" :class="{active: gender === 1}">
                  <div class="circle"></div>
                  <div class="note">男</div>
                </div>
                <div class="gender female"  @click="genderAction(2)" :class="{active: gender === 2}">
                  <div class="circle"></div>
                  <div class="note">女</div>
                </div>
              </div>
            </div>
            <div class="item item-intro" v-else-if="key === 'introduce'">
              <div class="name">{{value.field}}</div>
              <textarea v-model="formData[key]" :placeholder="`请输入您的【${value.field}】`"></textarea>
            </div>
            <div class="item item-normal" v-else>
              <div class="name">{{value.field}}</div>
              <input type="text" :name="key" v-model="formData[key]" :placeholder="`请输入您的【${value.field}】`">
            </div>
          </div>
        </section>
        <section class="submitBtn lottery-signup" @click="formSubmit" data-url="?m=front&subm=lottery&action=register">
          <span>提交</span>
        </section>
      </section>
    </div>
    <!-- 注册页信息end -->

    <!-- 需要关注二维码信息 -->
    <div class="wechat" v-if="focusData">
      <div class="wechatPic">
        <img :src="focusData.app_qr_code" alt="">
      </div>
      <div class="txtTip">
        <p>长按二维码，点击“识别二维码”按钮，关注我们</p>
        <p v-if="focusData.keyword">回复关键字“<span>{{focusData.keyword}}</span>”参与当前活动</p>
        <p>（若您已关注仍弹出此页面，则必须要到当前公众号下回复上诉关键字获取活动链接）</p>
      </div>
    </div>
    <!-- 需要关注二维码信息end -->

    <alert-tip v-if="alertStatus"
      @closeTip="againConfirm"
      :alertText="alertText"
      :confrimText='confrimText'
      :confrimUrl='confrimUrl'
      ></alert-tip>

    <!-- 遮罩背景阴影 -->
    <div class="cover" v-show="shade"></div>
  </div>
</template>

<script>
import { isWeixin } from '@/assets/js/tool'
import { getInit, getPrizeList, postRegister, getShareSuccess, getUdcData } from '@/api'

import squaredNine from '@/components/squaredNine'
import boxPassword from '@/components/boxPassword'
import scratchCard from '@/components/scratchCard'
import shakeTip from '@/components/shake'
import smashEggs from '@/components/smashEggs'
import turnTable from '@/components/turntable'

import alertTip from '@/components/alertTip'

const NOTE = {
  5007: '活动所需数据不足',
  5013: '该活动未开始',
  5014: '该活动已结束',
  5020: '该活动已被发布者下架或删除',
  5107: '该活动已被发布者下架或删除',
}

export default {
  data () {
    return {
      status: 0, // 活动状态
      prizePic: [
        require('../assets/images/prize_gift.png'),
        require('../assets/images/prize_tick.png'),
        require('../assets/images/prize_phone.png'),
        require('../assets/images/prize_pad.png'),
        require('../assets/images/prize_redbag.png'),
        require('../assets/images/prize_milk.png'),
        require('../assets/images/prize_wifi.png'),
      ],
      fromuser:'',
      prizeListImgDisplay: false,
      preHave:true,//用于控制是否直接进入活动，false正常进入活动模板页
      templateId: 0,//用于正常显示模板
      Data: null, // lotteryDetail存放活动模板需要渲染的数据（奖品说明，活动说明）
      focusData: null, // 强制关注数据
      prizeListData: null,
      tipInfo: '',
      formData: {}, // 表单提交数据
      rgtData: {},
      alertText:'',
      alertStatus: false,
      confrimText: '',
      confrimUrl: '',
      shade: false,
      preview: 0, // 预览模式，默认为否
      gender: 0, // 性别
      platRight: null, // 端信息
      coordinate: null, // 经纬度
    }
  },
  created() {
    // 存放活动地址
    sessionStorage.setItem('URL', window.location.href)
    this.init()
  },
  methods: {
    init() {
      // 初始化活动参数
      this.query = this.$route.query;
      if(this.query.from_user){
        this.fromuser = this.query.from_user;
      }
      // 初始化预览状态
      if (this.query.preview) {
        this.preview = 1
        sessionStorage.setItem('preview', true)
      } else {
        sessionStorage.removeItem('preview')
      }
      // 判断环境，是否是客户端
      this.isClient = sessionStorage.getItem('isClient') === '1'
      // 初始化入口，判断环境
      if (this.isClient) {
        const vm = this
        // 验证登陆
        CP.is_login(function(data) {
          // 已登录
          if (data.is_login == '1') {
            CP.get_unique_id(function (data) {
              vm.query.sessionid = data.unique_id;
              CP.get_account_id(function(data) {
                vm.query.account_id = data.account_id
                vm._getInit()
              })
            })
            // 统计参数，channel
            CP.get_client_info(function (data) {
              sessionStorage.setItem('channel', data.client_code)
            })
          } else {
            // 未登录，继续登陆
            CP.show_login(function(data) {
              // 已登录
              if (data.is_login === '1') {
                vm.query.account_id = data.account_id
                vm.query.sessionid = data.unique_id
                vm._getInit()
              } else {
                alert('取消登录')
              }
            })
          }
        })
      } else {
        // 初始化活动数据
        this._getInit()
        // 统计需要
        sessionStorage.setItem('channel', 'weixin')
      }
    },
    getLocation() {
      const vm = this
      CP.get_location_info(function (data) {
        vm.coordinate = {
          latitude: data.lat,
          longitude: data.lon
        }
      })
    },
    _getInit() {
      console.log('_getInit param', this.query)
      getInit(this.query).then(res => {
        console.log('getInit res', res)
        if (res.code === 3001) {
          this.Data = res.data;
          if(this.Data.page_title) {
            document.title = this.Data.page_title
            sessionStorage.setItem('raffleTitle', this.Data.page_title)
          }
          this._getPrizeList()
          // 地理位置信息初始化
          if (this.Data.is_gps === 1) {
            this.getLocation()
          }
          // 分享配置
          const shareConfig = {
            share_title: this.Data.share_title,
            share_desc: this.Data.share_desc,
            share_link: this.Data.share_link,
            share_img: this.Data.share_image
          }
          this.handleShareConfig(shareConfig)
          sessionStorage.setItem('shareConfig', JSON.stringify(shareConfig))
          // 端信息检查
          this.platRight = {
            url: this.Data.appDownUrl,
            right: this.Data.appisRight,
            name: this.Data.app_name,
            apptype: this.Data.apptype,
          }
        } else {
          switch (res.code) {
            case 5008:
              window.location.href = res.data.url;
              break;
            case 5007:
            case 5013:
            case 5014:
            case 5020:
            case 5107:
              this.status = 2
              this.tipInfo = NOTE[res.code];
              break;
            case 5011:
              this.shade = true;
              this.focusData = res.data;
              break;
            case 5110:
              const registerField = res.data.register_field;
              const L = registerField.length;
              for (let i = 0; i < L; i++) {
                // 拼装表单提交对象
                this.formData[registerField[i].name] = registerField[i].value
                // 改装数据，方便后面使用
                let key = registerField[i].name
                delete registerField[i].name
                let item = registerField[i]
                this.rgtData[key] = item
              }
              // 初始化性别信息
              if (this.rgtData.gender) {
                this.gender = this.rgtData.gender.value
              }
              this.status = 1
              break;
          }
        }
      })
    },
    handleShareConfig(shareConfig) {
      // 分享配置，先判断环境
      let vm = this

      if (isWeixin()) {
          getShareSuccess({
              preview: vm.preview,
              from_user:vm.fromuser
            }).then(res => {
          })
      }

      CP.set_share({
        completed: function(data) {
          CP.tools.writelog('分享设置成功set_share', data);
        },
        once: true,
        cp_incompatible:function () {
            CP.tools.writelog('set_share', '此环境不支持此方法');
        },
        success:function(data){
          // 客户端分享成功回调
          CP.tools.writelog('分享成功后的回掉set_share', data);
          // 因为以下功能仅实现于浙江新闻，为了与其它客户端匹配，所以暂时将它隐藏（分享成功后抽奖次数加1）
          // if(data.success=='1'){
          //   getShareSuccess({
          //       preview: vm.preview,
          //       from_user:vm.fromuser
          //   }).then(res => {
          //       console.log('--res-',成功了)
          //   })
          // }
        },
        title: shareConfig.share_title,
        shareSummary: shareConfig.share_desc,
        shareTo: '',
        link: shareConfig.share_link,
        imgUrl: shareConfig.share_img,
        id:'',
        type:'',
        datatype:'',
        dataUrl:'',
        shareUrlScheme:''
      })
    },
    genderAction(v) {
      this.gender = v
      this.formData.gender = v
    },
    _getPrizeList() {
      getPrizeList({
        preview: this.preview
      }).then(res => {
        if (res.code === 3001) {
          // 更新数据
          this.prizeListData = res.data
          // 奖品图片数据初始化
          this.picDisplayInit()
        }
      })
    },
    picDisplayInit() {
      if (this.picDisplayCheck()) {
        // 显示图片部分
        this.prizeListImgDisplay = true
        for (let i = 0; i < this.prizeListData.length; i++) {
          if (!this.prizeListData[i].image) {

            this.prizeListData[i].image =
              (this.prizeListData[i].fixed_image === 0) ?
                this.prizePic[0] :
                this.prizePic[this.prizeListData[i].fixed_image - 1]
          }
        }
      }
    },
    picDisplayCheck() {
      for (let i = 0; i < this.prizeListData.length; i++) {
        if (this.prizeListData[i].image || this.prizeListData[i].fixed_image) {
          return true
        }
      }
    },
    gotoAward(){//跳到奖品列表页面
      if (!this.preview) {
        this.$router.replace('AwardList');
      } else {
        this.alertPrize('预览模式无法操作！')
      }
    },
    alertPrize(awardName, confrimText, url){//处理中奖后的奖品信息
      console.log('index alertPrize:', awardName, confrimText, url)
      this.alertStatus = true;
      this.shade = true;
      this.alertText = awardName;
      this.confrimText = confrimText || '确认';
      this.confrimUrl = url
    },
    formSubmit(){//提交注册信息
      // 判断数据完整性
      for (let key in this.formData) {
        if (!this.formData[key]) {
          this.$toast('请填写完整信息!')
          return
        }
      }
      // 校验表单填写的内容
      let regExp
      for (let key in this.formData) {
        regExp = new RegExp(this.rgtData[key].regex)
        if (!regExp.test(this.formData[key])) {
          this.$toast(this.rgtData[key].msg)
          return
        }
      }
      let vm = this
      // 发起请求
      let formObj = {}
      for (let key in this.formData) {
        formObj[key] = this.formData[key]
      }
      postRegister({
        ...formObj,
        preview: this.preview
      }).then(res => {
        if (res.code === 3001) {
          this.status = 0
          this._getInit()
        }
      })
    },
    againConfirm(){//再次确认弹框
      this.alertStatus = false;
      this.shade = false;
    },
  },
  watch: {
    '$route' (to, from) {
      // 安卓手机中进行如下操作
      if (/android/i.test(navigator.userAgent)) {
        this.init()
      }
    }
  },
  components: {
    squaredNine,
    boxPassword,
    scratchCard,
    shakeTip,
    smashEggs,
    turnTable,
    alertTip
  },
}
</script>

<style lang="stylus" scoped>
.registerArea
  min-height: 100vh
  background-color: #f7f7f7
  overflow: hidden
</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
input,textarea{
  border: none;
  background: none;
}
.index{
  min-height: 100vh;
  background-color: #ffed5d;
  overflow: hidden;
}
.cover{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,.3);
  z-index: 3;
}
/*注册信息样式*/
    .setHeight{

    }
    .item{
      margin-bottom: 1rem;
      text-align: left;
      display: flex;
    }
      .genderOption {
        display: flex;
      }
        .gender {
          margin-left: 2em;
          display: flex;
          align-items: center;
        }
          .active {

          }
            .active > .circle {
              background-color: #409cf8
            }
            .active > .note {
              color: #409cf8
            }
          .circle {
            margin-right: 1em;
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 50%;
            border: 1px solid #ccc;
          }
    .name {
      margin-right: 2%;
      width: 20%;
      font-size: 14px;
      color:#48576a;
      text-align: right;
    }
    .item > input, .item > textarea {
      flex: 1;
      height: 2rem;
      border-radius: 4px;
      border: 1px solid#666;
      text-indent: 0.5em;
      appearance: none;
    }
    .item > input{
       height: 2rem;
    }
    .item > textarea{
      height: 4rem;
      resize:none;
    }
    .formInfo{
      width: 90%;
      margin: 0 auto;
    }
    .resg_title{
      color: #2d91dd;
      padding: 5% 0;
    }
    .tip{
      color: #d44b22;
      text-align: left;
      padding-bottom: 4%;
    }
    .submitBtn{
        width: 40%;
        background-color: #409cf8;
        margin: 8% auto;
        padding: 2% 0;
        border-radius: 5px;
        color: #fff;
    }
    /*关注微信*/
    .wechat{
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      z-index: 4;
    }
    .wechatPic{
      width: 300px;
      height: 300px;
      margin: 0 auto;
      margin-top: 10%;
      display: inline-block;
    }
    .wechatPic img{
      width: 100%;
    }
    .txtTip{
      color: #fff;
      font-size: 12px;
      width: 80%;
      margin: 0 auto;
      margin-top: 3%;
    }
    .txtTip span{
      color: #d44b22;
    }
    .activeStatus{
      height: 100vh;
      background-color: #fff;
      padding-top: 35%;
    }
    .activeStatus p{
      padding-top: 5%;
    }
</style>



// WEBPACK FOOTER //
// src/page/Index.vue